var map = {
	"./0°.png": 69203,
	"./120°.png": 56098,
	"./150°.png": 74533,
	"./180°.png": 54616,
	"./210°.png": 13500,
	"./240°.png": 88793,
	"./270°.png": 4954,
	"./300°.png": 88778,
	"./30°.png": 15224,
	"./330°.png": 21065,
	"./60°.png": 12797,
	"./90°.png": 90754
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 52560;